import { useAuth } from '@/features/auth/AuthContext'

/**
 * Hook providing the current tenant's schema name and metadata.
 * All tenant-scoped data hooks should use this to get the schema name.
 *
 * @example
 * const { schemaName, tenantId, isReady } = useTenant()
 *
 * return useQuery({
 *   queryKey: ['locations', schemaName],
 *   queryFn: () => tenantQuery(schemaName!).from('locations').select('*'),
 *   enabled: isReady,
 * })
 */
export function useTenant() {
  const { currentTenant, hasRole } = useAuth()

  const schemaName = currentTenant?.tenant.schema_name ?? null
  const tenantId = currentTenant?.tenant_id ?? null
  const tenantName = currentTenant?.tenant.name ?? null

  return {
    schemaName,
    tenantId,
    tenantName,
    isReady: !!schemaName,
    hasRole,
    currentTenant,
  }
}
